import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import colors from "./colors";
import "./Chip.scss";

const Chip = ({ classNames = "", children, bgColor }) => {
    const chipBgClassnames = cx(
        "chip__bg",
        bgColor &&
            Object.keys(colors)
                .map((color) => colors[color])
                .includes(bgColor) &&
            `chip__bg--${bgColor}`,
    );
    return (
        <div className={`chip ${classNames}`}>
            <div className="chip__inner">
                <div className={chipBgClassnames} />
                {children}
            </div>
        </div>
    );
};

Chip.propTypes = {
    // Bg color must match a value from the `colors` object
    // ⬇️ Grandfathered in from before Airbnb rules
    // eslint-disable-next-line react/require-default-props
    bgColor: PropTypes.oneOf(Object.keys(colors).map((color) => colors[color])),
    // ⬇️ Grandfathered in from before Airbnb rules
    // eslint-disable-next-line react/require-default-props
    classNames: PropTypes.string,
    // ⬇️ Grandfathered in from before Airbnb rules
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
    children: PropTypes.any,
};

export default Chip;
